__turbopack_context__.v({
  "backToTop": "footer-module-scss-module__TKzdpG__backToTop",
  "backToTopText": "footer-module-scss-module__TKzdpG__backToTopText",
  "bottomSection": "footer-module-scss-module__TKzdpG__bottomSection",
  "copyright": "footer-module-scss-module__TKzdpG__copyright",
  "facebook": "footer-module-scss-module__TKzdpG__facebook",
  "footer": "footer-module-scss-module__TKzdpG__footer",
  "footerContainer": "footer-module-scss-module__TKzdpG__footerContainer",
  "instagram": "footer-module-scss-module__TKzdpG__instagram",
  "language": "footer-module-scss-module__TKzdpG__language",
  "languageContainer": "footer-module-scss-module__TKzdpG__languageContainer",
  "linkColumn": "footer-module-scss-module__TKzdpG__linkColumn",
  "linkedin": "footer-module-scss-module__TKzdpG__linkedin",
  "linksGrid": "footer-module-scss-module__TKzdpG__linksGrid",
  "logo": "footer-module-scss-module__TKzdpG__logo",
  "logoContainer": "footer-module-scss-module__TKzdpG__logoContainer",
  "socialButton": "footer-module-scss-module__TKzdpG__socialButton",
  "socialLinks": "footer-module-scss-module__TKzdpG__socialLinks",
});
